import(/* webpackMode: "eager" */ "/opt/trendrain/trendrain-web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AssistantWidget"] */ "/opt/trendrain/trendrain-web/src/components/chat/AssistantWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/trendrain/trendrain-web/src/components/common/PullToRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/trendrain/trendrain-web/src/components/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNav"] */ "/opt/trendrain/trendrain-web/src/components/ui/BottomNav.tsx");
